import getLocale from "/utils/locale";
import loadScript from "/utils/load-script";
import notify from "/utils/notify";

let recaptchaInitialized = false;

const renderCaptcha = (captchaContainer, formPrefix) => {
  let captchaCompleted = false;

  const captchaErrorMessage = document.querySelector(`.js-${formPrefix}-captcha-error`);

  const captchaCompletedCallback = () => {
    captchaCompleted = true;
    captchaContainer.classList.remove(`${formPrefix}__captcha-container--error`);
    captchaErrorMessage.classList.remove(`${formPrefix}__captcha-error--show`);
  };

  const submitFormHandler = (e) => {
    if (!captchaCompleted && window.globals.recaptcha.activated) {
      e.preventDefault();
      captchaContainer.classList.add(`${formPrefix}__captcha-container--error`);
      captchaErrorMessage.classList.add(`${formPrefix}__captcha-error--show`);
    }
  };

  window.grecaptcha.render(captchaContainer, {
    sitekey: window.globals.recaptcha.v2_key,
    callback: captchaCompletedCallback
  });

  const submit = document.querySelector(`.js-${formPrefix}-submit`);
  if (!submit) {
    notify(`Can't find submit element in captcha with selector .js-${formPrefix}-submit`);
  } else {
    submit.addEventListener("click", submitFormHandler);
  }
};

const ensureCaptchaLibReady = () => {
  if (recaptchaInitialized) {
    return Promise.resolve();
  } else {
    return new Promise(resolve => {
      window.reCaptchaCallback = () => {
        recaptchaInitialized = true;
        resolve();
      };
    });
  }
};

const initCaptcha = (formPrefix) => {
  if (!window.globals.recaptcha.activated) return;
  let captchaContainer = document.querySelector(`.js-${formPrefix}-captcha`);
  if (!captchaContainer) return;

  loadScript(`https://www.google.com/recaptcha/api.js?render=explicit&onload=reCaptchaCallback&hl=${getLocale()}`)
    .then(ensureCaptchaLibReady)
    .then(() => renderCaptcha(captchaContainer, formPrefix))
    .catch(e => notify(`Can't load script ${e.target.src}`));
};

export const resetRecaptchaInitialized = () => {
  recaptchaInitialized = false;
  window.reCaptchaCallback = () => {
    recaptchaInitialized = true;
  };
};

resetRecaptchaInitialized();

export const eventHandlers = {
  // For the /login page
  "setup:ready": () => {
    initCaptcha("loginV2");
  },
  // For login popups
  "modal:auth-popup:step:login:opened": () => {
    initCaptcha("auth-form");
  }
};
